module.exports = __webpack_public_path__ + "media/images/icons/ghost-e75f10557bd1194fac683fbea443092c.svg";